import { NextSeo } from 'next-seo';
import { Fragment, useState, useRef } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import css from '../styles/modules/about/About.module.scss';
import SplitterFeed from '../components/SplitterFeed';

import ImageXml from '../public/images/xml.svg';

const XmlPage = () => {
  return (
    <Fragment>
      <NextSeo
        title="Автоматический импорт объявлений для агентств недвижимости"
        description="Автоматический импорт xml фида загрузка выгрузка объявлений посредство xml фид фида по недвижимости для агентств недвижимости"
        openGraph={{
          url: `https://${process.env.NEXT_PUBLIC_SITEDOMAIN}`,
          type: 'website',
          title: 'Автоматический импорт объявлений для агентств недвижимости',
          description:
            'Автоматический импорт xml фида загрузка выгрузка объявлений посредство xml фид фида по недвижимости для агентств недвижимости',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: process.env.NEXT_PUBLIC_SITENAME
        }}
      />
      <Header />
      <main className="core">
        <section className="block">
          <div className={['fixed', css.timeline].join(' ')}>
            <h2>Автоматическая выгрузка для агентств недвижимости</h2>
          </div>
        </section>
        <section className="block">
          <div className="fixed">
            <div className={css.bigMap}>
              <ImageXml />
            </div>
            <div className={css.description}>
              Мы принимаем автоматические XML-выгрузки в формате Яндекс.Недвижимость.
            </div>
            <div className={css.description}>
              Скопируйте ссылку на автовыгрузку в поле ниже и нажмите на кнопку "подключить фид".
            </div>
            <div className={css.description}>
              Мы разместим ваши объявления и будем автоматически обновлять их.
            </div>
            <p className={css.tip}>
              Фиды в формате Яндекс.Недвижимости, валидация происходит в соответствие с <a href="https://yandex.ru/support/realty/requirements/requirements-sale-housing.html" target="_blank">требованиям</a> Яндекс.Недвижимости.
            </p>
          </div>
          <div className={css.action}>
            <SplitterFeed
              title="Подключить фид"
            />
          </div>
        </section>
      </main>
      <Footer seo="Импорт xml файла на сайте База - подключить агентство" />
    </Fragment >
  );
};

export default XmlPage;
